// features/cartitemsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiurl } from "../Constants";

// Define an async thunk for fetching cart items
export const fetchCartItems = createAsyncThunk(
  "cartitems/fetchCartItems",
  async (user_id) => {
    const response = await axios.post(apiurl + "cart_list", {
      user_id: user_id,
    });

    return {
      products: response.data.products,
      grand_total: response.data.grand_total,
      shipping_amount: response.data.shipping_amount,
      total: response.data.total,
      total_weight: response.data.total_weight,
    };
  }
);

const cartitemsSlice = createSlice({
  name: "cartitems",
  initialState: {
    items: [],
    grand_total: 0,
    total: 0,
    shipping_amount: 0,
    total_weight: 0,
    status: "idle",
    error: null,
  },
  reducers: {
    updateGrandTotal: (state, action) => {
      state.grand_total = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCartItems.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCartItems.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload.products;
        state.grand_total = action.payload.grand_total;
        state.shipping_amount = action.payload.shipping_amount;
        state.total = action.payload.total;
        state.total_weight = action.payload.total_weight;
      })
      .addCase(fetchCartItems.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});
export const { updateGrandTotal } = cartitemsSlice.actions;
export default cartitemsSlice.reducer;
